import * as React from 'react';

export const InformationIcon = React.forwardRef<SVGSVGElement>(
  function InformationIcon(_props: unknown, ref) {
    return (
      <svg
        className="align-text-top inline-block"
        ref={ref}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="18" height="18" fill="white" fillOpacity="0.01" />
        <rect width="18" height="18" rx="9" fill="#0099C7" />
        <path
          d="M7.85866 14V6.90909H9.52983V14H7.85866ZM8.69886 5.9027C8.43419 5.9027 8.20644 5.81499 8.01562 5.63956C7.82481 5.46106 7.7294 5.24716 7.7294 4.99787C7.7294 4.7455 7.82481 4.5316 8.01562 4.35618C8.20644 4.17767 8.43419 4.08842 8.69886 4.08842C8.96662 4.08842 9.19437 4.17767 9.3821 4.35618C9.57292 4.5316 9.66832 4.7455 9.66832 4.99787C9.66832 5.24716 9.57292 5.46106 9.3821 5.63956C9.19437 5.81499 8.96662 5.9027 8.69886 5.9027Z"
          fill="white"
        />
      </svg>
    );
  }
);
